import React from "react";
import { TextField } from "@mui/material";
import { FormikProps } from "formik";
import Grid2 from "@mui/material/Grid2"; // استفاده از Grid2

// ساخت schema برای اعتبارسنجی با yup

const SystemWebForm = ({ formik }: { formik: FormikProps<any> }) => {
  return (
    <>
      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={9}>
          <TextField
            {...formik.getFieldProps("name")} // استفاده از ویژگی‌های فرمیک
            label="نام سامانه"
            placeholder="نام سامانه"
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={(formik.touched.name && formik.errors.name) as boolean}
            variant="outlined"
            fullWidth
          />
        </Grid2>
        <Grid2 size={3}>
          <TextField
            {...formik.getFieldProps("priorityShow")} // استفاده از ویژگی‌های فرمیک
            label="اولویت نمایش"
            placeholder="اولویت نمایش"
            type="number"
            error={
              formik.touched.priorityShow && Boolean(formik.errors.priorityShow)
            }
            helperText={
              (formik.touched.priorityShow &&
                formik.errors.priorityShow) as boolean
            }
            variant="outlined"
            fullWidth
          />
        </Grid2>
      </Grid2>

      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={12}>
          <TextField
            {...formik.getFieldProps("url")} // استفاده از ویژگی‌های فرمیک
            label="لینک سامانه"
            placeholder="لینک سامانه"
            error={formik.touched.url && Boolean(formik.errors.url)}
            helperText={(formik.touched.url && formik.errors.url) as boolean}
            variant="outlined"
            fullWidth
          />
        </Grid2>
      </Grid2>
    </>
  );
};

export default SystemWebForm;
